import { SnackbarVariant } from '@eas/common-web';
import {
  addStartingPointCoords,
  stringifyCoords,
} from '@modules/planner/unit-menu/utils';
import { planWorkOrder } from '@modules/work-order/work-order-api';
import { getDrivingInfo } from '@composite/map/utils/get-driving-info';
import { GPSPoint, WorkOrder } from '@models';
import { WorkOrderDto } from './prepare-dto';
import { updateEdgeWorkOrdersTravelTime } from './update-edge-work-order-travel';

export const planSingleWorkOrder = async ({
  newWorkOrder,
  newWorkOrderDto,
  prevWorkOrder,
  nextWorkOrder,
  unitStartingPoint,
  isMultiDay,
}: {
  nextWorkOrder: WorkOrder | undefined;
  prevWorkOrder: WorkOrder | undefined;
  newWorkOrder: WorkOrder;
  newWorkOrderDto: WorkOrderDto;
  unitStartingPoint: GPSPoint;
  isMultiDay: boolean;
}) => {
  const newWorkOrderTravel = {
    previous: 0,
    next: 0,
  };
  if (!nextWorkOrder || nextWorkOrder.id === newWorkOrder.id) {
    const woCoords = stringifyCoords([newWorkOrder]);
    const travelNextCoords = addStartingPointCoords(
      woCoords,
      unitStartingPoint,
      'end'
    );
    const travelTime = await getDrivingInfo(travelNextCoords);
    newWorkOrderTravel.next = Math.round(travelTime.duration);
  }
  if (!prevWorkOrder || prevWorkOrder.id === newWorkOrder.id) {
    const woCoords = stringifyCoords([newWorkOrder]);
    const travelPreviousCoords = addStartingPointCoords(
      woCoords,
      unitStartingPoint,
      'start'
    );
    const travelTime = await getDrivingInfo(travelPreviousCoords);
    newWorkOrderTravel.previous = Math.round(travelTime.duration);
  } else {
    const coordsPrevious = stringifyCoords([prevWorkOrder, newWorkOrder]);
    const travelTime = await getDrivingInfo(coordsPrevious);
    newWorkOrderTravel.previous = Math.round(travelTime.duration);
  }

  try {
    await planWorkOrder(
      newWorkOrderDto.id,
      {
        ownerType: newWorkOrderDto.unitType,
        ownerId: newWorkOrderDto.unitId,
        plannedFrom: newWorkOrderDto.plannedFrom,
        plannedTo: newWorkOrderDto.plannedTo,
        travelNext: newWorkOrderTravel.next,
        travelPrevious: newWorkOrderTravel.previous,
      },
      isMultiDay
    ).json();

    await updateEdgeWorkOrdersTravelTime({
      workOrder: newWorkOrder,
      nextWorkOrder:
        nextWorkOrder?.id === newWorkOrder.id ? undefined : nextWorkOrder,
      prevWorkOrder:
        prevWorkOrder?.id === newWorkOrder.id ? undefined : prevWorkOrder,
    });
    return { ok: true, error: '', snackbarVariant: SnackbarVariant.SUCCESS };
  } catch (error) {
    const code = (error as { code: string })?.code ?? 'DEFAULT';
    const snackbarVariant = snackbarVariantsEnum[code] ?? SnackbarVariant.ERROR;
    const errorMsg =
      planWorkOrderErrorCodesEnum[code] ?? planWorkOrderErrorCodesEnum.DEFAULT;
    return {
      ok: false,
      error: errorMsg,
      snackbarVariant,
    };
  }
};

export const planWorkOrderErrorCodesEnum: { [key: string]: string } = {
  MUZA_SYNC_REQUIRED:
    'Nepodarilo sa naplánovať pracovný príkaz: čaká sa na dokončenie synchronizácie s MUZA.',
  DEFAULT: `Nepodarilo sa naplánovať pracovný príkaz.`,
  FORBIDDEN_STATE_CHANGE: 'Nepovolená zmena stavu pracovného príkazu.',
};

export const snackbarVariantsEnum: { [key: string]: SnackbarVariant } = {
  MUZA_SYNC_REQUIRED: SnackbarVariant.WARNING,
  DEFAULT: SnackbarVariant.ERROR,
  FORBIDDEN_STATE_CHANGE: SnackbarVariant.ERROR,
};
